'use client'

import { Factory } from '@/app/[locale]/(landing-page)/supplier/_components/supplier-data'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface HeroBannerProps {
  factory: Factory
}

export function HeroBanner({ factory }: HeroBannerProps) {
  const t = useTranslations('landing_supplier')

  return (
    <div className='relative h-[250px] w-full md:h-[400px]'>
      <Image
        src={ImageHelper.getImageUrlCdn(factory.image)}
        alt={t(`${factory.i18nKey}.name`)}
        fill
        className='object-cover'
        priority
      />
      <div className='absolute inset-0 bg-black/40' />
      <div className='absolute inset-0 flex items-center justify-center'>
        <h1 className='text-center font-criteria text-3xl font-bold text-white md:text-5xl'>
          {t(`${factory.i18nKey}.name`)}
        </h1>
      </div>
    </div>
  )
}
